/*!
 * Stimpack Header
 *
 * @version : 1.0
 * @author  : Matthias Courville
 */

(function($){

    $('#header').each(function() {

        var body = $('body'),
            header = $(this),
            lastScrollTop = 0,
            lastScrollTopDelta = 0;

        $(window).on('scroll', function() {

            var scrollTop = $(window).scrollTop();

            // Reach Top
            if (scrollTop >= header.offset().top)
            {
                body.addClass('header-top-reached');
            }
            else
            {
                body.removeClass('header-top-reached');
            }

            // Reach Bottom
            if (scrollTop >= (header.offset().top + header.height()))
            {
                body.addClass('header-bottom-reached');
            }
            else
            {
                body.removeClass('header-bottom-reached');
            }

            lastScrollTop = scrollTop;
        });
    });

})(jQuery);
